<template>
    <v-dialog v-model="mostrar" persistent max-width="600px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Modificar partida</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field 
                                v-model="numero" 
                                name="SG-NU-numero" 
                                label="Número:"
                                :error-messages="errors.numero"
                                @input="validarNumero()"
                                @blur="validarNumero()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="COG"
                                :items="catalogoPartidas"
                                item-text="clave"
                                item-value="_id"
                                label="COG:"
                            >
                             </v-autocomplete>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="conceptoGasto" 
                                name="SG-NU-conceptoGasto" 
                                label="Concepto:"
                                :error-messages="errors.conceptoGasto"
                                @input="validarConceptoGasto()"
                                @blur="validarConceptoGasto()"
                                >
                            </v-text-field>
                        </v-col> -->
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="descripcion" 
                                name="SG-NU-descripcion" 
                                label="Descripción:"
                                readonly
                                :error-messages="errors.descripcion"
                                @input="validarDescripcion()"
                                @blur="validarDescripcion()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field 
                                v-model="aplicacion" 
                                name="SG-NU-aplicacion" 
                                label="Aplicación:"
                                :error-messages="errors.aplicacion"
                                @input="validarAplicacion()"
                                @blur="validarAplicacion()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="montoInicial" 
                                name="SG-NU-montoInicial" 
                                label="Monto inicial:"
                                :error-messages="errors.montoInicial"
                                @input="validarMontoInicial()"
                                @blur="validarMontoInicial()"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="teal darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="teal darken-1" dark @click="guardarPartida()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, integer, decimal } from 'vuelidate/lib/validators'
import axios from 'axios'
import { mapGetters} from 'vuex'
import moment from 'moment'
moment.locale('es');

export default {
    props:['mostrar','partida'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        catalogoPartidas: [],
        numero: null,
        COG: null,
        conceptoGasto: null,
        descripcion: null,
        aplicacion: 'Gasto de operación',
        montoInicial: null,
        errors:{
            numero: [],
            COG: [],
            descripcion: [],
            conceptoGasto: [],
            aplicacion: [],
            montoInicial: []
        },
    }),
    validations: {
        numero: { required, integer },
        COG: { required },
        descripcion: { required },
        // conceptoGasto: { required, integer },
        aplicacion: { required },
        montoInicial: { required, decimal }
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    watch:{
        COG(nuevo){
            let partida = this.catalogoPartidas.find(x=>x._id == nuevo);
            if(partida) this.descripcion = partida.descripcion;
        }
    },
    async created(){
        this.loading = true;
        await axios.get(this.httpURL+'/partidas/catalogo',
        {headers:{token:this.sessionToken}})
        .then(res => {
            // console.log(res.data);
            this.loading = false;
            if( res.data.ok ){
                this.catalogoPartidas = res.data.partidas;
            }else{
                if( res.data.numero ) this.errors.numero = [res.data.mensaje];
                if( !res.data.numero )
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
            }
        })
        .catch(error => {
            // console.log('Error: '+error);
            this.loading = false;
            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
        });
        this.numero = this.partida.numero;
        this.COG = this.partida.COG._id;
        // this.conceptoGasto = this.partida.conceptoGasto;
        // this.descripcion = this.partida.descripcion;
        this.aplicacion = this.partida.aplicacion;
        this.montoInicial = this.partida.montoInicial;
    },
    methods: {
        validarNumero(){
            this.$v.numero.$touch();
            const errors = []
            if (this.$v.numero.$dirty){
                !this.$v.numero.required && errors.push('Campo requerido.')
                !this.$v.numero.integer && errors.push('Debe ingresar un número.')
            }
            this.errors.numero = errors;
        },
        validarCOG(){
            this.$v.COG.$touch();
            const errors = []
            if (this.$v.COG.$dirty){
                !this.$v.COG.required && errors.push('Campo requerido.')
            }
            this.errors.COG = errors;
        },
        validarDescripcion(){
            this.$v.descripcion.$touch();
            const errors = []
            if (this.$v.descripcion.$dirty){
                !this.$v.descripcion.required && errors.push('Campo requerido.')
            }
            this.errors.descripcion = errors;
        },
        validarConceptoGasto(){
            this.$v.conceptoGasto.$touch();
            const errors = []
            if (this.$v.conceptoGasto.$dirty){
                !this.$v.conceptoGasto.required && errors.push('Campo requerido.')
                !this.$v.conceptoGasto.integer && errors.push('Debe ingresar un número.')
            }
            this.errors.conceptoGasto = errors;
        },
        validarAplicacion(){
            this.$v.aplicacion.$touch();
            const errors = []
            if (this.$v.aplicacion.$dirty){
                !this.$v.aplicacion.required && errors.push('Campo requerido.')
            }
            this.errors.aplicacion = errors;
        },
        validarMontoInicial(){
            this.$v.montoInicial.$touch();
            const errors = []
            if (this.$v.montoInicial.$dirty){
                !this.$v.montoInicial.required && errors.push('Campo requerido.')
                !this.$v.montoInicial.decimal && errors.push('Debe ingresar un número.')
            }
            this.errors.montoInicial = errors;
        },
        guardarPartida(){
            this.$v.$touch();
            this.validarNumero();
            this.validarCOG();
            this.validarDescripcion();
            // this.validarConceptoGasto();
            this.validarAplicacion();
            this.validarMontoInicial();
            if (!this.$v.$invalid) {
                this.loading = true;
                axios.put(this.httpURL+'/partida/'+this.partida._id,
                {
                    numero: this.numero,
                    COG: this.COG,
                    descripcion: this.descripcion,
                    // conceptoGasto: this.conceptoGasto,
                    aplicacion: this.aplicacion,
                    montoInicial: this.montoInicial
                },
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        let cog = this.catalogoPartidas.find(x=>x._id == res.data.partida.COG);
                        let partida = res.data.partida;
                        partida.COG = cog;
                        this.$emit('partidaModificada', partida);
                        this.loading = false;
                    }else{
                        if( res.data.numero ) this.errors.numero = [res.data.mensaje];
                        if( !res.data.numero )
                            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        this.loading = false;
                    }
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            }
        }
    }
}
</script>